export default function register( state = { 'OUTPUT' : { 'DATA' : [1] } }, action = {} ){

	switch( action.type ){
		case 'SAVE_USER':
			return action.register
		default: return state;
	}

}



// WEBPACK FOOTER //
// ./src/store/reducers/register/register.reducer.js